import { inject, Injectable, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export type ThemeMode = 'light' | 'dark';

const THEME_STORAGE_KEY = '1p-theme-mode';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly _document = inject(DOCUMENT);

  private readonly _isDark = signal<boolean>(this._loadFromStorage());
  readonly isDark = this._isDark.asReadonly();

  constructor() {
    this._applyTheme(this._isDark());
  }

  toggle(): void {
    const next = !this._isDark();
    this._isDark.set(next);
    localStorage.setItem(THEME_STORAGE_KEY, next ? 'dark' : 'light');
    this._applyTheme(next);
  }

  private _loadFromStorage(): boolean {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored !== null) return stored === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  private _applyTheme(dark: boolean): void {
    const body = this._document.body;
    if (dark) {
      body.classList.add('dark-mode');
    } else {
      body.classList.remove('dark-mode');
    }
  }
}
